const RICH_TEXT_TYPES = Object.freeze({
  buttonLink: 'buttonLink',
  customImage: 'customImage',
  simpleText: 'simpleText',
  videoEmbed: 'videoEmbed',
  pbRichText: "pbRichText",
  testimonial: "testimonial",
});

export default RICH_TEXT_TYPES;
